import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=2e9bd942&scoped=true"
import script from "./Paginate.vue?vue&type=script&lang=js"
export * from "./Paginate.vue?vue&type=script&lang=js"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=2e9bd942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9bd942",
  null
  
)

export default component.exports